export enum PreAssessmentStep {
  IRQ = 'irq',
  START = 'start',
}
